// extracted by mini-css-extract-plugin
export default {"tagsContainer":"style_tagsContainer__B5dLP","tag":"style_tag__E2Nls"};